import { glassOverlay as e, glassSurface as t } from "../../theme/theme.mjs";
import { useMobile as n } from "../../hooks/useMobile.mjs";
import { MobileFullscreen as r } from "../Popup/Popup.mjs";
import i from "react";
import { css as a, keyframes as o, styled as s } from "styled-components";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
import * as u from "@radix-ui/react-dialog";
//#region src/components/Modal/Modal.tsx
var d = o`
    from { opacity: 0; }
    to { opacity: 1; }
`, f = o`
    from { opacity: 0; transform: translate(-50%, -48%) scale(0.96); }
    to   { opacity: 1; transform: translate(-50%, -50%) scale(1); }
`, p = s(u.Overlay)`
    position: fixed;
    inset: 0;
    ${e};
    z-index: 1000;
    animation: ${d} ${({ theme: e }) => e.transitions.fast} ease;
`, m = {
	sm: "400px",
	md: "560px",
	lg: "720px",
	xl: "900px",
	"2xl": "1180px",
	fullscreen: "100vw"
}, h = a`
    > form {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
    }
`, g = s(u.Content)`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${({ $size: e }) => m[e]};
    max-width: ${({ $size: e }) => e === "fullscreen" ? "100vw" : "calc(100vw - 32px)"};
    max-height: ${({ $size: e }) => e === "fullscreen" ? "100vh" : "90vh"};
    ${t};
    border-radius: ${({ theme: e }) => e.radii.xl};
    display: flex;
    flex-direction: column;
    z-index: 1001;
    overflow: hidden;
    animation: ${f} ${({ theme: e }) => e.transitions.fast} ease;
    outline: none;
    /* Full-bleed: drop the glass border/radius (it has no backdrop to sit within). */
    ${({ $size: e }) => e === "fullscreen" && "border-radius: 0; border: none; height: 100vh;"}

    ${h}
`, _ = s(u.Content)`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: ${({ theme: e }) => e.colors.card};
    outline: none;

    ${h}
`, v = s.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: ${({ theme: e }) => e.spacing(3)};
    border-bottom: 1px solid ${({ theme: e }) => e.colors.border};
    gap: ${({ theme: e }) => e.spacing(2)};
    flex-shrink: 0;

    @media (max-width: 640px) {
        padding: ${({ theme: e }) => e.spacing(2)};
    }
`, y = s.div`
    flex: 1;
    overflow-y: auto;
    padding: ${({ theme: e }) => e.spacing(3)};
    /* Solid inset layer over the frosted shell — keeps body content legible. */
    background-color: ${({ theme: e }) => e.colors.card};
    border-radius: ${({ theme: e }) => e.radii.lg};
    margin: 0 ${({ theme: e }) => e.spacing(3)} ${({ theme: e }) => e.spacing(3)};

    /* Margin stacks on padding, so a phone loses it twice over; 16px + 8px keeps
       the inset-card look at a third of the cost. */
    @media (max-width: 640px) {
        padding: ${({ theme: e }) => e.spacing(2)};
        margin: 0 ${({ theme: e }) => e.spacing(1)} ${({ theme: e }) => e.spacing(1)};
    }
`, b = s.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${({ theme: e }) => e.spacing(2)};
    padding: ${({ theme: e }) => e.spacing(3)};
    border-top: 1px solid ${({ theme: e }) => e.colors.border};
    flex-shrink: 0;

    @media (max-width: 640px) {
        padding: ${({ theme: e }) => e.spacing(2)};
    }
`, x = s(u.Title)`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.xl};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    color: ${({ theme: e }) => e.colors.cardForeground};
    margin: 0;
    line-height: ${({ theme: e }) => e.typographyTokens.lineHeights.tight};
`, S = s(u.Description)`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    margin: 0;
    margin-top: ${({ theme: e }) => e.spacing(.5)};
`, C = s(u.Close)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    background-color: transparent;
    color: ${({ theme: e }) => e.colors.mutedForeground};
    border-radius: ${({ theme: e }) => e.radii.md};
    cursor: pointer;
    flex-shrink: 0;
    transition: all ${({ theme: e }) => e.transitions.fast};

    &:hover {
        background-color: ${({ theme: e }) => e.colors.muted};
        color: ${({ theme: e }) => e.colors.foreground};
    }
`, w = u.Root, T = u.Trigger, E = u.Portal, D = i.forwardRef(({ children: e, size: t = "md", mobileFullscreen: i = !1, hideOverlay: a = !1, closeOnOverlayClick: o = !0, ...s }, u) => {
	let { isMobile: d } = n();
	return i && d ? /* @__PURE__ */ c(E, { children: /* @__PURE__ */ c(r, {
		open: !0,
		children: /* @__PURE__ */ c(_, {
			ref: u,
			onInteractOutside: (e) => e.preventDefault(),
			...s,
			children: e
		})
	}) }) : /* @__PURE__ */ l(E, { children: [!a && /* @__PURE__ */ c(p, { onClick: o ? void 0 : (e) => e.stopPropagation() }), /* @__PURE__ */ c(g, {
		ref: u,
		$size: t,
		onInteractOutside: (e) => {
			o || e.preventDefault();
		},
		...s,
		children: e
	})] });
});
D.displayName = "ModalContent";
var O = i.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ c(C, {
	ref: n,
	...t,
	children: e || /* @__PURE__ */ c("svg", {
		width: "16",
		height: "16",
		viewBox: "0 0 16 16",
		fill: "none",
		children: /* @__PURE__ */ c("path", {
			d: "M12 4L4 12M4 4l8 8",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round"
		})
	})
}));
O.displayName = "ModalClose";
//#endregion
export { w as Modal, y as ModalBody, O as ModalClose, D as ModalContent, S as ModalDescription, b as ModalFooter, v as ModalHeader, p as ModalOverlay, E as ModalPortal, x as ModalTitle, T as ModalTrigger, C as StyledCloseButton, g as StyledContent };
